import Navbar from "@/components/Navbar";

const SECTIONS = [
  {
    title: "1. Qui sommes-nous",
    body: `VantaPulse (« nous », « notre service ») édite une plateforme permettant d'acheter, configurer et gérer des produits numériques (bots Discord, scripts pour serveurs FiveM...) sous forme d'abonnements ou de licences à vie. La présente politique explique quelles données nous collectons lorsque vous utilisez le site vanta-pulse.shop, pourquoi, et quels sont vos droits.`,
  },
  {
    title: "2. Données que nous collectons",
    body: `Lors de la création de votre compte (par email, ou via Google/Discord) : votre adresse email, votre pseudo, votre photo de profil et, si vous vous connectez avec Discord, votre identifiant Discord.
Votre mot de passe n'est jamais stocké en clair : il est chiffré (hashage bcrypt) avant d'être enregistré.
Si vous activez l'authentification à deux facteurs (A2F), la clé associée est stockée de façon sécurisée.
Lors d'un achat : les informations de facturation nécessaires. Vos coordonnées bancaires ne transitent jamais par nos serveurs — elles sont traitées directement par notre prestataire de paiement, Stripe.
Lorsque vous contactez le support (humain ou l'assistant IA) : le contenu de vos messages et pièces jointes, afin de vous répondre.
Lorsque vous utilisez Vanta AI (page /ai) : vos conversations et les fichiers que vous y ajoutez, pour vous les afficher et vous répondre. L'équipe VantaPulse peut les consulter pour la modération, le support et l'amélioration du service ; chaque consultation est enregistrée. Vous pouvez supprimer vos conversations à tout moment depuis Vanta AI.
Des données techniques : adresse IP, horodatage des connexions et journaux de sécurité, utilisés pour protéger votre compte contre les accès non autorisés.`,
  },
  {
    title: "3. Pourquoi nous utilisons ces données",
    body: `Créer et sécuriser votre compte, vous permettre de vous connecter (y compris par mot de passe oublié ou A2F).
Fournir et faire fonctionner les produits que vous avez achetés (bots Discord, licences de scripts).
Traiter vos paiements et votre facturation.
Répondre à vos demandes de support.
Détecter et prévenir la fraude, les abus et les accès non autorisés.
Améliorer le site et nos services.`,
  },
  {
    title: "4. Avec qui nous partageons vos données",
    body: `Nous ne vendons jamais vos données personnelles. Elles sont partagées uniquement avec les prestataires nécessaires au fonctionnement du service :
Stripe, pour le traitement des paiements.
Notre hébergeur de base de données et nos hébergeurs applicatifs (Render, Vercel), pour faire fonctionner le site.
Google et Discord, lorsque vous choisissez de vous connecter via ces services (authentification OAuth).
Le fournisseur d'intelligence artificielle utilisé par notre assistant de support, à qui le contenu de vos messages de support peut être transmis pour générer une réponse.
Ces prestataires n'utilisent vos données que pour le compte de VantaPulse et dans le cadre strictement nécessaire à leur prestation.`,
  },
  {
    title: "5. Durée de conservation",
    body: `Vos données de compte sont conservées tant que votre compte existe. Si vous désactivez votre compte (Paramètres → Zone de danger), il peut être réactivé en vous reconnectant. Si vous demandez la suppression définitive de votre compte, vos données personnelles (profil, identifiants de connexion) sont supprimées ; les données de facturation nécessaires à nos obligations comptables et légales peuvent être conservées séparément pendant la durée requise par la loi.`,
  },
  {
    title: "6. Sécurité",
    body: `Les mots de passe sont hashés, les connexions au site sont chiffrées (HTTPS), et vous pouvez activer l'authentification à deux facteurs (application d'authentification ou code par email) pour renforcer la sécurité de votre compte.`,
  },
  {
    title: "7. Vos droits",
    body: `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et de portabilité de vos données.
Vous pouvez modifier vos informations et gérer votre compte directement depuis Paramètres. Vous pouvez demander la suppression définitive de votre compte depuis Paramètres → Zone de danger, ou en nous contactant.
Pour toute autre demande relative à vos données, contactez-nous à support@vantapulse.fr.`,
  },
  {
    title: "8. Cookies",
    body: `Nous utilisons uniquement des cookies et technologies de stockage local nécessaires au fonctionnement du site (maintien de votre session de connexion, préférences). Nous n'utilisons pas de cookies publicitaires tiers.`,
  },
  {
    title: "9. Modifications",
    body: `Cette politique peut être mise à jour pour refléter des évolutions du service ou de la réglementation. La date de dernière mise à jour est indiquée en haut de cette page.`,
  },
  {
    title: "10. Contact",
    body: `Pour toute question concernant cette politique ou vos données personnelles : support@vantapulse.fr`,
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <Navbar />
      <main className="pt-24 pb-16 max-w-4xl mx-auto px-6">
        <h1 className="text-3xl font-bold mb-2">Politique de confidentialité</h1>
        <p className="text-white/40 text-sm mb-10">Dernière mise à jour : 24 septembre 2026</p>
        <div className="space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="text-xl font-semibold text-white mb-3">{s.title}</h2>
              <p className="text-white/60 leading-relaxed whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
